import { render, staticRenderFns } from "./area-select.vue?vue&type=template&id=46bb0dc4&scoped=true"
import script from "./area-select.vue?vue&type=script&lang=ts"
export * from "./area-select.vue?vue&type=script&lang=ts"
import style0 from "./area-select.vue?vue&type=style&index=0&id=46bb0dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb0dc4",
  null
  
)

export default component.exports